import { MEMBER_JOIN_STAT_SEARCH } from "../actionTypes";
const initialState = {
  members: null,
  filterSource: { fromDate: '', toDate: '' },
  Loading: true
};
function reducer(state = initialState, action) {
  switch (action.type) {
    case "reset":
      return initialState;
    case MEMBER_JOIN_STAT_SEARCH:
      return {
        ...state,
        members: action.payload.data,
        filterSource: action.payload.filterSource,
        Loading: false
      };
    default:
      return state;
  }
}

export { reducer as default }
